

function formatReal(int) {
  var tmp = int + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
  if (tmp.length > 6)
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

  return tmp;
}

const total = localStorage.getItem('totalPrice');
$('.customPrice').text(formatReal(total));

const select = $('<select>');
// const select = $('#selectOptionKit');
// const ComboBoxKitOptions = $('#ComboBoxKitOptions');



let valorGlobal = '';
function obterProduto(handle, callback, ) {
  $.ajax({
    type: "GET",
    url: '/products/' + handle + '.js',
    dataType: 'json',
    success: function (product) {
      callback(product.variants[0].id, product.price, product.available, product.title);
      

      if (product.tags.includes('modelo_estoque')) {
        console.log(product.variants[0].id);
        const idEnviar = product.variants[0].id;
        valorGlobal = idEnviar;
      }
      const variants = product.variants.filter(variant => variant.available === true);

    

      if (product.tags.includes('custom_variant')) {
        variants.forEach((variant, idx) => {
          const option = $('<option>')
            .text(variant.title)
            .attr('id', variant.id)
            .attr('name', variant.title)
            .attr('value', variant.id);

          // const comboOpt = `<button
          //   type="button"
          //   role="option"
          //   class="combo-box__option-item"
          //   value="${variant.title}"
          //   aria-selected="false"
          // >
          //   ${variant.title}
          // </button>`;

          select.append(option);
          // ComboBoxKitOptions.append(comboOpt);
        });

        $('#CustomSelect').append(select);
        // $('#selectOptionKit').append(select);
      }
    }
  });
}

let itensadd = [];

let handleProducts = $('.handleProduct');
let totalProducts = handleProducts.length;
let productsProcessed = 0;
let totalPrice = 0;

let modelo;
let valorInicial = '-';



select.on('change', function() {
  const selectedValue = $(this).val();
  const selectedOption = $(this).find('option:selected');
  const testName = selectedOption.attr('name');
  console.log('testName', testName )
  console.log(selectedValue);


  modelo = testName;
  valorInicial = selectedValue;

  if (valorInicial === '-') {
    $('.CustomAddKit').hide();
    $('.CustomChamaModal').show();
   
  }else{
    $('.CustomChamaModal').hide();
    $('.CustomAddKit').show();
   
  }
});


$('.CustomChamaModal').click(function() {
 
    $('.modalCustom').show();

 
});

$('.closeCustom').click(function(){
  $('.modalCustom').hide();
})

handleProducts.each(function(index) {
  let handleProd = $(this).val();
  obterProduto(handleProd, function(id, price) {
    

    totalPrice += price;
    localStorage.setItem('totalPrice', totalPrice);

    productsProcessed++;
    //let productExists = itensadd.some(item => item.id === id);
    // if (!productExists) {
    //   itensadd.push({
    //     'id': 42640827908261,
    //     'quantity': 1,
    //     properties: {
    //       'Propertis': modelo
    //     }
    //   });
    //   itensadd.push({
    //     'id': id,
    //     'quantity': 1,
    //     properties: {
    //       'Propertis': modelo
    //     }
    //   });
    // }
    // $('#CustomAddKit').click(function() {
    //   debugger
    //   if (productsProcessed === totalProducts) {
    //     itensadd.forEach(item => {
    //       item.properties['Modelo'] = modelo;
    //     });
       

    //     let formData = {
    //       'items': itensadd
    //     };

    //     fetch(window.Shopify.routes.root + 'cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(formData)
    //     })
    //       .then(response => {
    //         if (response.ok) {
    //           return response.json();
    //         } else {
    //           return response.json().then(errorData => {
    //             alert(errorData.description);
    //             throw new Error('Erro ao adicionar o produto ao carrinho: ' + errorData.description);
    //           });
    //         }
    //       })
    //       .then(data => {
    //       //  $('.customMsgKit').show()
    //         $.getJSON('/cart.js', (cart) => {
    //           $('.header__cart-count').text(cart.item_count)
    //       });
    //         $('#mini-cart').load(window.location.href + " " + '#mini-cart > *');
    //         // setTimeout(() => {
    //         //   $('.customMsgKit').hide()
    //         // }, 2000);
    //         $("#mini-cart").attr("open", "true");
    //       })
         
    //       .catch(error => {
    //         console.error('Erro ao adicionar o produto ao carrinho:', error.message);
    //         const errorMessage = error.message.split(': ')[1];

    //         const mensagemErroElemento = document.getElementById('mensagemErro');
    //         mensagemErroElemento.innerText = errorMessage;
    //       });
    //   }
    // });
  });
});

$('#CustomAddKit').click(function() {

  itensadd = [];
    itensadd.push({
      'id': valorInicial,
      'quantity': 1,
      
    }),
    itensadd.push({
      'id': valorGlobal,
      'quantity': 1,
      properties: {
        'Modelo': modelo
      }
    });
  

  let formData = {
    'items': itensadd
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        return response.json().then(errorData => {
          alert(errorData.description);
          throw new Error('Erro ao adicionar o produto ao carrinho: ' + errorData.description);
        });
      }
    })
    .then(data => {
      $.getJSON('/cart.js', (cart) => {
        $('.header__cart-count').text(cart.item_count);
      });
      $('#mini-cart').load(window.location.href + " " + '#mini-cart > *');
      $("#mini-cart").attr("open", "true");
    })
    .catch(error => {
      console.error('Erro ao adicionar o produto ao carrinho:', error.message);
      const errorMessage = error.message.split(': ')[1];

      const mensagemErroElemento = document.getElementById('mensagemErro');
      mensagemErroElemento.innerText = errorMessage;
    });

});





$(document).on('click', '.header__icon-wrapper.tap-area', function() {
  $('#mini-cart').load(window.location.href + " " + '#mini-cart > *');
});

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.getElementById('AddToCart');
  const btnFake = document.getElementById('CustomChamaModal');
  const btnFake2 = document.getElementById('CustomChamaModalCompre');
  const CustomBtnComprar = document.getElementById('Gbtn');

  const buttons = document.getElementsByClassName('custom-select-default__option');
  const modal = document.getElementById("myModalCustom");
  const span = document.getElementsByClassName("closeCustom")[0];
  const stickyAdd = document.getElementById('StickyAddToCart');

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function breakButtonWords() {
    if (isMobileDevice()) {
      const buttons = document.querySelectorAll('.tabs-nav__item');

      buttons.forEach(button => {
        if (button.textContent.includes(' ')) {
          const words = button.textContent.split(' ');

          button.innerHTML = `${words[0]}<br>${words[1]}`;
        }
      });
    }
  }

  window.addEventListener('load', breakButtonWords);

  // let valorSelecionado = '-';

  // if (valorSelecionado === '-') {
  //   addToCartButton.style.display = "none";
  //   stickyAdd.setAttribute('disabled', 'disabled');
    
  // } else {
  //   btnFake.style.display = "none";
  //   btnFake2.style.display = "none";
    
  // }

  // Array.from(buttons).forEach(button => {
    document.querySelector('.custom-select-default').addEventListener('change', (e) => {
      const valor = e.target.value;
      valorSelecionado = valor;

      if (valorSelecionado === '-') {
        if(addToCartButton){
          addToCartButton.style.display = "none";
        }
        if(CustomBtnComprar){
          CustomBtnComprar.style.display = "none";
        }        
        if(btnFake){
          btnFake.style.display = "block";
        }
        if(btnFake2){
          btnFake2.style.display = "block";
        }
        if(stickyAdd){
          stickyAdd.setAttribute('disabled', 'disabled');
        }
      } else {
        if(addToCartButton){
          addToCartButton.style.display = "block";
        }
        if(stickyAdd){
          stickyAdd.setAttribute('disabled', 'disabled');
        }
        if(btnFake){
          btnFake.style.display = "none";
        }
        if(btnFake2){
          btnFake2.style.display = "none";
        }
        if(CustomBtnComprar){
          CustomBtnComprar.style.display = "block";
        }
      }
    });
  // });

  if(btnFake){
    btnFake.addEventListener('click', function() {
      if (valorSelecionado === '-') {
        modal.style.display = "block";
      } else {
        console.log('faz o envio');
      }
    });
  }

  if(stickyAdd){
    stickyAdd.addEventListener('click', function() {
      if (valorSelecionado === '-') {
        modal.style.display = "block";
      } else {
        console.log('faz o envio');
      }
    });
  }

  span.onclick = function() {
    modal.style.display = "none";
  };

  window.onclick = function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  };
});

window.addEventListener('load', function() {
  // const primeiraOpcao = document.querySelector('.custom-select-default__option');
  // if(primeiraOpcao){
  //   primeiraOpcao.click();
  // }
  const optSelect = document.querySelector('.custom-select-default');
  if(optSelect){
    const firstValue = optSelect.querySelector('option:first-child').value;
    optSelect.value = firstValue
    optSelect.dispatchEvent(new Event('change'));
  }

  // custom drop kit
  const dropKit = $('#selectOptionKit');
  if(dropKit[0]){
    dropKit.on('change', (event) => {
      const item = $(event.target);
      const id = item.find(`option[value="${item.val()}"]`).attr('data-id');
      $('#CustomSelect select').val(id);
      select.change();
    })
  }
});
